import { z } from "zod";
import { isoDate } from "./common.js";

export const auditEventSchema = z.object({
  id: z.string(),
  action: z.string(),
  actorEmail: z.string().nullable(),
  targetType: z.string().nullable(),
  targetId: z.string().nullable(),
  metadata: z.record(z.unknown()).nullable(),
  createdAt: isoDate,
});
export type AuditEvent = z.infer<typeof auditEventSchema>;
